<template>
  <div class="flex flex-col gap-4">
    <div>
      <base-label id="email" label="Email Address"/>
      <base-input id="email"
                  name="email"
                  variant="editor"
                  type="email"
                  :class="['w-full py-px mt-1 h-10', fieldErrors.email ? 'border-focus-error focus:border-focus-error' : 'border-gray']"
                  :value="formData.email"
                  @input="$emit('update:email', $event)"
                  placeholder="example@company.com"
      />
      <span v-if="fieldErrors.email" class="text-xs text-focus-error mt-1">{{ fieldErrors.email }}</span>
    </div>

    <div>
      <base-label id="subject" label="Email Subject"/>
      <base-input id="subject"
                  name="subject"
                  variant="editor"
                  type="text"
                  :class="['w-full py-px mt-1 h-10', fieldErrors.subject ? 'border-focus-error focus:border-focus-error' : 'border-gray']"
                  :value="formData.subject"
                  @input="$emit('update:subject', $event)"
                  placeholder="Customer Support Request"
      />
      <span v-if="fieldErrors.subject" class="text-xs text-focus-error mt-1">{{ fieldErrors.subject }}</span>
    </div>

    <div v-if="showUnreleased">
      <base-label id="format" label="Email Format" :is-admin="true"/>
      <base-select id="format"
                   :value="formData.format"
                   :options="formatOptions"
                   class="w-full border-gray mt-1 h-10"
                   @input="$emit('update:format', $event)"
      />
    </div>

    <div v-if="showUnreleased">
      <base-label id="sendgridTemplateId"
                  label="SendGrid Template ID"
                  tooltip="The ID is bound specifically to TEXT or HTML. It will not work with the other option. So, be sure you know what your doing."
                  :is-admin="true"
      />
      <base-input id="sendgridTemplateId"
                  name="sendgridTemplateId"
                  variant="editor"
                  type="text"
                  :class="['w-full py-px mt-1 h-10', fieldErrors.sendgrid_template_id ? 'border-focus-error focus:border-focus-error' : 'border-gray']"
                  :value="formData.sendgrid_template_id"
                  @input="$emit('update:sendgridTemplateId', $event)"
                  placeholder="d-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
      />
      <span v-if="fieldErrors.sendgrid_template_id" class="text-xs text-focus-error mt-1">{{ fieldErrors.sendgrid_template_id }}</span>
    </div>

    <div>
      <base-label id="timezone" label="Timezone"/>
      <queryable-select id="timezone"
                        :value="formData.timezone"
                        :options="timezoneOptions"
                        class="w-full border-gray mt-1 h-10"
                        @input="$emit('update:timezone', $event)"
      />
    </div>

    <div>
      <base-label id="bots"
                  label="Bots"
      />
      <queryable-select id="bots"
                        :value="selectedBotId"
                        :options="botOptions"
                        overlay-dropdown
                        :class="['w-full mt-1 h-10', fieldErrors.bots ? 'border-focus-error' : 'border-gray']"
                        :is-disabled="loaders.bots"
                        @input="$emit('update:botId', $event)"
      />
      <span v-if="fieldErrors.bots" class="text-xs text-focus-error mt-1">{{ fieldErrors.bots }}</span>
      <span v-else-if="loaders.bots" class="text-xs text-gray-dark mt-1">Loading bots...</span>
      <span v-else-if="botOptions.length === 0 && !isEditMode" class="text-xs text-gray-dark mt-1">No bots available. Please create a bot first.</span>
    </div>
  </div>
</template>

<script>
import BaseSelect from '@/components/base-components/BaseSelect.vue'
import QueryableSelect from '@/components/common/QueryableSelect.vue'
import mixins from '@/utils/mixins'
import { EMAIL_FORMATS } from '@/utils/integration.constants'

export default {
  name: 'EmailHelpdeskIntegrationForm',
  
  components: { BaseSelect, QueryableSelect },
  mixins: [mixins],
  
  props: {
    formData: {
      type: Object,
      required: true,
      validator: (value) => {
        return 'email' in value &&
               'subject' in value &&
               'sendgrid_template_id' in value &&
               'timezone' in value
      }
    },
    selectedBotId: {
      type: String,
      default: ''
    },
    fieldErrors: {
      type: Object,
      default: () => ({})
    },
    timezoneOptions: {
      type: Array,
      required: true
    },
    botOptions: {
      type: Array,
      required: true
    },
    loaders: {
      type: Object,
      default: () => ({ bots: false })
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  
  emits: ['update:email', 'update:subject', 'update:sendgridTemplateId', 'update:timezone', 'update:botId', 'update:format'],

  computed: {
    formatOptions() {
      return [
        { text: 'HTML', value: EMAIL_FORMATS.HTML },
        { text: 'Text', value: EMAIL_FORMATS.TEXT }
      ]
    }
  }
}
</script>
